export enum RequestState {
	Initial,
	Started,
	Complete,
	Error
}
